import React from "react";
import classnames from 'classnames';
import "./launcher-signup.scss";
import _content from "../../constants/launcher-signup.json";
import GameLogo from "./GameLogo";
import LanguageSelector from "./LanguageSelector";

const LauncherSignUp = (props) => {
  const gameLogoHover = game => {
    console.log('GO');
    props.setGame(game);
  }

  const renderLogos = () => {
    const { game: currentGame, global, lang } = props;
    return Object.keys(global.data.games).map((game, i) => (
      <GameLogo
        key={i}
        content={global.data}
        game={game}
        currentGame={currentGame}
        currentLang={lang}
        handleLogoHover={gameLogoHover}
      />
    ));
  };

  const renderLanguageSelector = () => {
    const { global, lang, game } = props;
    return (
      <LanguageSelector
        content={global.data.languages}
        currentLang={lang}
        currentGame={game}
      />
    );
  };

  const { game, lang } = props;

  const classList = classnames(`${game}-active`);

  return (
    <div id="launcher-signup-page" className={classList}>
      <div className="content-wrapper">
        <h1>{_content.global.headline[lang]}</h1>
        {renderLanguageSelector()}
        {renderLogos()}
      </div>
      {
        _content.global.info[game] &&
        <p className='info'>
          <i className="fas fa-exclamation-circle" />
          {_content.global.info[game][lang]}
        </p>
      }
    </div>
  );
};

export default LauncherSignUp
